import { flexRender, type Table } from '@tanstack/react-table'

import cn from './AtomTableHeader.module.scss'

type AtomTableHeaderProps<TData> = {
  table: Table<TData>
}

function AtomTableHeader<TData>({ table }: AtomTableHeaderProps<TData>) {
  return (
    <div role="rowgroup">
      {table.getHeaderGroups().map((headerGroup) => (
        <div key={headerGroup.id} role="row" className={cn.header}>
          {headerGroup.headers.map((header) => (
            <div key={header.id} role="columnheader" className={cn.headerCell}>
              {header.isPlaceholder
                ? null
                : flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default AtomTableHeader
